import React, { useEffect, useRef, useState } from "react";
import "./style.scss";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../store";
import CalendarModal from "../CalendarSale/CalendarModal/CalendarModal";
import { MdArrowBackIosNew } from "react-icons/md";
import { IoLocationOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { setExerciseName, setExerciseZoneId } from "../../store/pseudoModal/pseudoModalsActions";
import EAButton from "../shared/Buttons/EAButton";
import { CALENDAR_SALE } from "../../routes";
import { goToPreviousPage } from "../../../utils/goToPreviousPage";
import EAChip from "../shared/Chip/EAChip";

const ModalWindow: React.FC = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const exerciseNames = useSelector((state: State) => state.pseudoModals.exerciseName);
  const exercisesZoneId = useSelector((state: State) => state.pseudoModals.exerciseZoneId);
  const exerciseDescription = useSelector((state: State) => state.pseudoModals.exerciseDescription);

  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);
  const [showDescriptionToggle, setShowDescriptionToggle] = useState(false);
  const descriptionRef = useRef<HTMLDivElement>(null);

  // Ten sam wzorzec co TourDetails: sprawdź czy opis przekracza ~3 linie, jeśli tak
  // pokaż przycisk "Pokaż więcej". Kilka prób z rosnącym opóźnieniem, żeby złapać
  // moment gdy HTML w pełni się wyrenderuje.
  useEffect(() => {
    const MAX_HEIGHT = 180;
    const timers: NodeJS.Timeout[] = [];

    const checkHeight = () => {
      if (descriptionRef.current) {
        setShowDescriptionToggle(descriptionRef.current.scrollHeight > MAX_HEIGHT);
      }
    };

    timers.push(setTimeout(checkHeight, 50));
    timers.push(setTimeout(checkHeight, 150));
    timers.push(setTimeout(checkHeight, 300));

    return () => timers.forEach((timer) => clearTimeout(timer));
  }, [exerciseDescription]);

  const getQueryParam = (key: string): string => {
    const query = location.search.startsWith("?") ? location.search.slice(1) : location.search;
    const regex = new RegExp(`(?:^|&)${key}=([^&]*)`);
    const match = query.match(regex);
    return match ? decodeURIComponent(match[1]) : "";
  };

  const exerciseIdsParam = getQueryParam("exerciseIds");
  const exerciseNameParam = getQueryParam("exerciseName");
  const exerciseLocationParam = getQueryParam("location");

  // Opis potrafi przyjść jako czysty tekst z wieloma pustymi liniami (\n\n\n...) zamiast
  // realnych akapitów <p> — normalizujemy do pojedynczych, żeby zdania stały ciasno,
  // jedno pod drugim, zamiast robić duże odstępy akapitowe.
  const normalizedDescription = exerciseDescription?.replace(/\n{2,}/g, "\n").trim();

  useEffect(() => {
    if (exerciseNameParam && exerciseIdsParam) {
      dispatch(setExerciseName(exerciseNameParam));
      dispatch(setExerciseZoneId(Number(exerciseIdsParam)));
    }
    //eslint-disable-next-line
  }, [exerciseIdsParam, exerciseNameParam]);

  return (
    <React.Fragment>
      <div className="modal-window-header">
        <EAButton
          title={t("wroc")}
          onClick={() => goToPreviousPage(navigate, CALENDAR_SALE)}
          startIcon={<MdArrowBackIosNew />}
          variant="text"
          noMargins
        />
        <div className="modal-window-header__content">
          <h1 className="no-margins">
            {t("kup_bilet")}:<b>{exerciseNames}</b>
          </h1>
          {exerciseLocationParam && (
            <EAChip
              label={exerciseLocationParam}
              icon={<IoLocationOutline />}
              variant="primary"
              className="modal-window-header__location-chip"
            />
          )}
        </div>

        {normalizedDescription && (
          <div className="modal-window-header__description-container">
            <article
              ref={descriptionRef}
              className={
                isDescriptionExpanded
                  ? "modal-window-header__description modal-window-header__description--expanded"
                  : "modal-window-header__description"
              }
              dangerouslySetInnerHTML={{ __html: normalizedDescription }}
            />
            {showDescriptionToggle && (
              <EAButton
                title={isDescriptionExpanded ? t("pokaz_mniej") : t("pokaz_wiecej")}
                onClick={() => setIsDescriptionExpanded(!isDescriptionExpanded)}
                variant="text"
                noMargins
              />
            )}
          </div>
        )}
      </div>
      <div>
        {exerciseNames.length > 2 && exercisesZoneId && (
          <CalendarModal exerciseName={exerciseNames} zone={exercisesZoneId} />
        )}
      </div>
    </React.Fragment>
  );
};

export default ModalWindow;
